// config/tableConfigs/ticketManagement.js
// Mirrors the SchemeManagement config pattern for Ticket Management

export const TicketManagement = {
  title: "Ticket Management",
  subtitle: "Manage and track all support tickets",
  apiUrl: "https://api.mokshiq.in/ticket_manager_action",

  // ── Columns shown in DataTable ──────────────────────────────────────────
  columns: [
    { key: "ticket_id",    label: "Ticket ID",    sortable: true,  width: "120px" },
    { key: "title",        label: "Subject",       sortable: true,  width: "220px" },
    { key: "ticket_type",  label: "Type",          sortable: true,  width: "120px" },
    { key: "priority",     label: "Priority",      sortable: true,  width: "100px" },
    { key: "status",       label: "Status",        sortable: true,  width: "120px" },
    { key: "assigned_to",  label: "Assigned To",   sortable: false, width: "140px" },
    { key: "amount",       label: "Amount (₹)",    sortable: true,  width: "110px" },
    { key: "created_at",   label: "Created",       sortable: true,  width: "130px" },
    { key: "actions",      label: "Actions",       sortable: false, width: "110px" },
  ],

  // ── Badge colour mappings ─────────────────────────────────────────────
  badgeMap: {
    status: {
      open:        { label: "Open",        color: "#3b82f6", bg: "rgba(59,130,246,.13)" },
      in_progress: { label: "In Progress", color: "#f59e0b", bg: "rgba(245,158,11,.13)" },
      pending:     { label: "Pending",     color: "#a78bfa", bg: "rgba(167,139,250,.13)" },
      resolved:    { label: "Resolved",    color: "#10b981", bg: "rgba(16,185,129,.13)" },
      closed:      { label: "Closed",      color: "#64748b", bg: "rgba(100,116,139,.13)" },
    },
    priority: {
      low:      { label: "Low",      color: "#10b981", bg: "rgba(16,185,129,.13)" },
      medium:   { label: "Medium",   color: "#3b82f6", bg: "rgba(59,130,246,.13)" },
      high:     { label: "High",     color: "#f59e0b", bg: "rgba(245,158,11,.13)" },
      critical: { label: "Critical", color: "#ef4444", bg: "rgba(239,68,68,.13)"  },
    },
  },

  // ── Role-based permission matrix ──────────────────────────────────────
  //  Roles correspond to your Role model: main_admin / admin / white_label /
  //  super_distributor / distributor / retailer
  permissions: {
    main_admin:        { canCreate: true,  canEdit: true,  canDelete: true,  canView: true,  canExport: true,  canAssign: true  },
    admin:             { canCreate: true,  canEdit: true,  canDelete: true,  canView: true,  canExport: true,  canAssign: true  },
    white_label:       { canCreate: true,  canEdit: true,  canDelete: false, canView: true,  canExport: true,  canAssign: true  },
    super_distributor: { canCreate: true,  canEdit: true,  canDelete: false, canView: true,  canExport: false, canAssign: false },
    distributor:       { canCreate: true,  canEdit: false, canDelete: false, canView: true,  canExport: false, canAssign: false },
    retailer:          { canCreate: true,  canEdit: false, canDelete: false, canView: true,  canExport: false, canAssign: false },
  },

  // ── Filter / search fields ────────────────────────────────────────────
  filters: [
    { key: "status",      label: "Status",   type: "select",
      options: ["", "open", "in_progress", "pending", "resolved", "closed"] },
    { key: "priority",    label: "Priority", type: "select",
      options: ["", "low", "medium", "high", "critical"] },
    { key: "ticket_type", label: "Type",     type: "select",
      options: ["", "payment", "kyc", "fraud", "account", "bug", "support"] },
  ],

  // ── Ticket type options (used in form) ────────────────────────────────
  ticketTypeOptions: [
    { value: "payment",  label: "💳 Payment Issue"    },
    { value: "kyc",      label: "🪪 KYC / Compliance"  },
    { value: "fraud",    label: "🚨 Fraud Alert"       },
    { value: "account",  label: "👤 Account Issue"     },
    { value: "bug",      label: "🐛 Bug / Technical"   },
    { value: "support",  label: "🎧 General Support"   },
  ],

  statusOptions: [
    { value: "open",        label: "Open"        },
    { value: "in_progress", label: "In Progress" },
    { value: "pending",     label: "Pending"     },
    { value: "resolved",    label: "Resolved"    },
    { value: "closed",      label: "Closed"      },
  ],

  priorityOptions: [
    { value: "low",      label: "Low"      },
    { value: "medium",   label: "Medium"   },
    { value: "high",     label: "High"     },
    { value: "critical", label: "Critical" },
  ],
};